import React, { useState } from "react";
import "./SubscribeBanner.css";
import useUIStyles from "../../../Hooks/useUIStyles";
import { publicAxios } from "../../../config/apiConfig";

const SubscribeBanner = () => {
  const { heading, title, description } = useUIStyles();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const frontendBase = window.location.origin;
      await publicAxios.post("subscribe", { email }, {
        headers: { "X-Frontend-Base-Url": frontendBase }
      });
      setMessage("Check your email for a confirmation link.");
      setEmail("");
    } catch (err) {
      console.error(err);
      setMessage("Failed to subscribe. Try again later.");
    } finally {
      setLoading(false);
      setTimeout(() => setMessage(""), 10000);
    }
  }

  return (
    <div className="py-16 px-4 bg-gradient-to-br from-gray-900 via-gray-800 to-black relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://static3.azafashions.com/uploads/landing_page_section_content_image/1739961847912get-insider-access-top.png)`,
          opacity: 0.3
        }}
      />

      {/* Content Overlay */}
      <div className="relative z-10 max-w-7xl mx-auto px-[0.25%]">
        {/* Section Header */}
        <div className="text-center mb-8">
          <h2
            className="section-heading text-3xl md:text-4xl text-white"
          >
            Subscribe to our newsletter
          </h2>
          <p className="text-lg text-gray-200 mt-4 max-w-2xl mx-auto">
            Get exclusive access to new collections, special offers, and fashion insights
          </p>
        </div>

        {/* Enhanced Subscription Form */}
        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 px-6 py-4 rounded-full border-0 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-900 text-lg"
            />
            <button
              disabled={loading}
              type="submit"
              className="px-8 py-4 bg-brand text-white rounded-full font-medium text-sm tracking-wide hover:bg-brand-dark transition-colors whitespace-nowrap"
            >
              {loading ? "SENDING..." : "SUBSCRIBE"}
            </button>
          </div>
          {message && (
            <div className="flex justify-center mt-2">
              <div className="px-2 py-1 bg-green-600 text-white rounded-full inline-flex items-center animate-pulse shadow-md">
                <svg
                  className="w-3 h-3 mr-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-sm font-medium">{message}</span>
              </div>
            </div>
          )}

        </form>

        {/* Additional Benefits */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Early Access</h3>
            <p className="text-gray-400">Get first dibs on new collections</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Exclusive Offers</h3>
            <p className="text-gray-400">Special discounts just for subscribers</p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h3 className="text-lg font-semibold text-white mb-2">Style Tips</h3>
            <p className="text-gray-400">Expert fashion advice and trends</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscribeBanner;
